import { styled } from "@mui/material/styles";
import { AppBar, Link } from "@mui/material";

export const StyledAppBar = styled(AppBar)({
  textAlign: "center",
  padding: "10px 0",
});

export const StyledLink = styled(Link)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  textTransform: "uppercase",
  "&:hover": {
    "@media (hover: hover)": {
      textDecoration: "underline",
    },
  },
}));
